import { observable } from 'mobx';

export enum SituacaoDoDeposito {
  inexistente = -1,
  pendente,
  aprovado,
  reprovado,
}

export class DepositoModel {
  readonly id: number = -1;
  @observable public conteudoDoArquivo: File | null = null;
  @observable public conteudoDoArquivoPath: any = '';
  @observable public situacao: SituacaoDoDeposito = SituacaoDoDeposito.inexistente;
  @observable public justificativaDaReprovacao: string = '';
  @observable public dataDoDeposito: Date;
  @observable public identifier: string;
}
